import React from "react";
import { ApproveBody, PublishBody } from "./DialogBodies.jsx";
import { ApprovingPanel, PdfReadyCard, PublishedCard, PublishingPanel } from "./Panels.jsx";

/**
 * `?fixture=report-flow` -- the six steps of the approve -> PDF -> publish
 * flow side by side, the way the owner-approved Approve.dc.html draws them.
 * It exists so the artboard gate can compare the REAL flow components (the
 * same ApproveBody / PublishBody / panels the screen renders) against that
 * design; it is never reachable from the app's navigation. The sample facts
 * (page count, size, client name, the report's own file name) are the design's
 * own; the live screen shows only what the backend returns.
 */
const FILE = "SS418 Progress Report September 1-October 10, 2026.pdf";

export default function FlowGallery() {
  const approve = {
    version: 2, periodText: "1 Sep – 10 Oct 2026",
    editedAt: "2026-10-10T10:40:00.000Z", confirmedAt: "2026-10-10T09:14:00.000Z",
  };
  const publish = { code: "SS418", fileName: "SS418 Progress Report September 1-…, 2026.pdf", whoSees: "Mercury Maritime project members" };
  return (
    <div className="page wr-page" data-testid="report-flow-gallery">
      <div className="wr-gal">
        <div className="wr-ghead">
          <h1>Approve and publish · SS418 report</h1>
          <span>What the site manager sees, step by step, inside the project card</span>
        </div>
        <div className="wr-ggrid">
          <section className="wr-gsec">
            <span className="wr-glabel">1 · CONFIRM APPROVAL</span>
            <div className="wr-dialog static">
              <ApproveBody d={approve} onCancel={() => {}} onConfirm={() => {}} titleId="wr-g1" />
            </div>
            <span className="wr-gnote">Any draft in the list can be approved this way, not only the newest.</span>
          </section>

          <section className="wr-gsec">
            <span className="wr-glabel">2 · APPROVED, PDF BEING MADE</span>
            <ApprovingPanel code="SS418" title="Approved v2 · 11:02" detail="Usually under 30 seconds. The buttons stay off until it is done." />
          </section>

          <section className="wr-gsec">
            <span className="wr-glabel">3 · PDF READY</span>
            <PdfReadyCard code="SS418" fileName={FILE} sizeLabel="21 pages · 2.4 MB">
              <div className="wr-actions">
                <a className="wr-btn" style={{ boxSizing: "content-box" }} href="#pdf">Open PDF</a>
                <button type="button" className="wr-btn pri">Publish to project site</button>
              </div>
              <button type="button" className="wr-linkbtn">Reopen as draft…</button>
            </PdfReadyCard>
          </section>

          <section className="wr-gsec">
            <span className="wr-glabel">4 · CONFIRM PUBLISH</span>
            <div className="wr-dialog static">
              <PublishBody d={publish} onCancel={() => {}} onConfirm={() => {}} titleId="wr-g4" />
            </div>
          </section>

          <section className="wr-gsec">
            <span className="wr-glabel">5 · PUBLISHING</span>
            <PublishingPanel code="SS418" title="Publishing the approved report…" doneCount={1} />
          </section>

          <section className="wr-gsec">
            <span className="wr-glabel">6 · PUBLISHED</span>
            <PublishedCard linkBox="content-box" code="SS418" label="Report 3" stamp="Sat 10 Oct 11:20" siteUrl="#site" nextLabel="Start next report" onNext={() => {}} />
            <div className="wr-errbox" style={{ maxWidth: "none" }}>
              <strong>If something fails</strong>
              <span>PDF not created → "Retry PDF". Copy differs or a file with that name is already on the site → nothing is overwritten; the report stays Approved and the message says what to do.</span>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
